var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancegreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 0.999756C11.5807 0.999796 13.1327 1.41568 14.5008 2.20561C15.869 2.99554 17.0051 4.13169 17.795 5.49986C18.5849 6.86802 19.0007 8.42 19.0007 9.99981C19.0007 11.5796 18.5848 13.1316 17.7949 14.4998L10.0049 10.0028L10.0009 0.999756Z",
    fill: "#4AB58E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00061 9.99976C1.00061 11.1817 1.2334 12.352 1.68569 13.4439C2.13799 14.5358 2.80092 15.528 3.63665 16.3637C4.47238 17.1994 5.46453 17.8624 6.55646 18.3147C7.64839 18.767 8.81871 18.9998 10.0006 18.9998C11.1825 18.9998 12.3528 18.767 13.4448 18.3147C14.5367 17.8624 15.5288 17.1994 16.3646 16.3637C17.2003 15.528 17.8632 14.5358 18.3155 13.4439C18.7678 12.352 19.0006 11.1817 19.0006 9.99976C19.0006 7.61281 18.0524 5.32362 16.3646 3.63579C14.6767 1.94797 12.3876 0.999756 10.0006 0.999756C7.61366 0.999756 5.32448 1.94797 3.63665 3.63579C1.94882 5.32362 1.00061 7.61281 1.00061 9.99976Z",
    stroke: "#4AB58E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancegreen);
export default __webpack_public_path__ + "static/media/financegreen.c6b82b3e08b5014fac33bb0473bb8c52.svg";
export { ForwardRef as ReactComponent };